import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// --- NOVO: Importa o App Check ---
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// As suas chaves do Firebase continuam a vir do ficheiro .env.local
const firebaseConfig = {
  apiKey: "AIzaSyCTJQSfEHemrvVQPpfvQvNhocvVq2ykcAg",
  authDomain: "gestorpro-f2c42.firebaseapp.com",
  projectId: "gestorpro-f2c42",
  storageBucket: "gestorpro-f2c42.firebasestorage.app",
  messagingSenderId: "64557109515",
  appId: "1:64557109515:web:2121f817ebfc78f75b120e"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// --- NOVO: Inicializa o App Check ---
// Lê a chave do site que você adicionou ao ficheiro .env.local
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// Só inicializa se a chave existir, para evitar erros
if (recaptchaSiteKey) {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      // Ativa a atualização automática dos tokens de segurança
      isTokenAutoRefreshEnabled: true
    });
    console.log("Firebase App Check inicializado com sucesso.");
} else {
    console.warn("Chave do reCAPTCHA não encontrada. App Check não foi inicializado.");
}
// --- FIM DO CÓDIGO NOVO ---

// Inicializa os outros serviços do Firebase
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;